// extracted by mini-css-extract-plugin
module.exports = {"sustainabilityGRDWrapper":"style_sustainabilityGRDWrapper__K0cIa"};